<div class="tab-list__filter ms-bgc-nl">
    <input autocomplete="off"
           type="text"
           id="tab-list-input"
           placeholder="{{ filterPlaceholderText }}"
           class="tab-list__filter__input ms-fcl-ns ms-bgc-nl"
           [attr.aria-label]="filterSearchAriaLabel"
           (input)="onInputChange($event)"
           #tabListFilterInputText />
    <button class="tab-list__filter__icon-button"
            [ngClass]="{'icon-button--disabled': !filterText}"
            [disabled]="!filterText"
            [title]="filterInputButtonAriaLabel"
            (click)="onClearTextFilter()"
            [tabindex]="!!filterText ? 0 : -1"
            data-clicklog="custom">
        <ohp-icon-font [ngClass]="{'ms-fcl-tp': !!filterText, 'ms-fcl-ns': !filterText}"
                       [iconFontType]="filterIcon"
                       [size]="16">
        </ohp-icon-font>
    </button>
</div>
